import {
  takeEvery,
  fork,
  put,
  all,
  call,
  takeLatest,
  delay,
} from "redux-saga/effects";
import {
  GET_LICENSE,
  GET_LICENSE_SUCCESSFUL,
  GET_LICENSE_FAILED,
  UPDATE_LICENSE,
  ADD_COMPLIANCE_ADDONS,
} from "./actionTypes";
import {
  getLicense as getLicenseAction,
  getLicenseSuccessful,
  getLicenseFailed,
  updateLicenseSuccessful,
  updateLicenseFailed,
  addComplianceAddons as addComplianceAddonsAction,
  addComplianceAddonsSuccessful,
  addComplianceAddonsFailed,
} from "./actions";
import {
  getGlobalLicense,
  updateGlobalLicense,
  addComplianceAddons as addComplianceAddonsApi,
} from "../../helpers/auth_helper";

// function* addCognitoUser({ payload: {user} }){
//     try {
//         console.log("Add Cognito User :: ", user)
//         const response = yield call(addUser, {
//             firstname: user.firstname,
//             lastname: user.lastname,
//             username: user.email,
//             password: user.password,
//             groupname: user.groupName
//         });
//         console.log("Called")
//         yield put(addUserSuccessfull(response));
//         yield put(getLicenseAction());
//     } catch (error) {
//         console.log("Error is :: ", error.response.data)
//         yield put(addUserError(error));
//     }
// }

function* getLicense({ payload: {orgCode} }) {
  try {
    console.log("about to call *getLicense()");
    const response = yield call(getGlobalLicense, orgCode);
    console.log("*getLicense() response: ", response);

  if(response && response.status === 200){  
    delete response.status;
    yield put(getLicenseSuccessful(response));
  }else {
    yield put(getLicenseFailed({message: response.message}));
  }

  } catch (error) {
    if (error.response) {
      yield put(getLicenseFailed({message: "Error Code: "+error.response?.status+", Message: "+ error.response?.data}));
    } else if(error.request){
      yield put(getLicenseFailed({message: "No response received"}));
    }
    yield put(getLicenseFailed({message: error?.message}));
  }
}

//Added for update/delete cognito user

// function* deleteCognitoUser({ payload: { username } }) {
//   try {
//     console.log("Delete Cognito User :: ", username);
//     const response = yield call(deleteUser, {
//       username: username,
//     });
//     console.log("Delete Cognito User API Called");
//     yield put(deleteCognitoUserSuccessful(response));
//     //Added the following to update the redux store, after delete is successful
//     console.log("Calling getUser() from deleteCognitoUser saga...");
//     yield delay(2000);
//     yield put(getLicenseAction());

//   } catch (error) {
//     console.log("Delete Cognito User API Error is :: ", error);
//     yield put(deleteCognitoUserFailed(error));
//   }
// }

// function* updateCognitoUser({ payload: { user } }) {
//         console.log(
//           "saga -> updateCognitoUser called with",
//           user
//         );

//   try {
//     console.log("Update Cognito User :: ", user);
//     // const response = yield call(updateUser, {
//     //     firstName: user.firstName,
//     //     lastName: user.lastName,
//     //     username: user.username,
//     //     groupname: user.groupname
//     // });
//     const response = yield call(updateUser, user);
//     console.log("Update Cognito User API Called");
//     yield put(updateCognitoUserSuccessful(user));
//     //Added the following to update the redux store, after update is successful
//     console.log("Calling getUser() from updateCognitoUser saga...");
//     yield delay(2000);
//     yield put(getLicenseAction());
//   } catch (error) {
//     console.log("Update Cognito User API Error is :: ", error);
//     yield put(updateCognitoUserFailed(error));
//   }
// }

function* updateLicense({ payload: { license } }) {
  try {
    console.log("about to call *updateLicense()");
    const response = yield call(updateGlobalLicense, license);
    console.log("updateGlobalLicense() response: ", response);

    if (response && response.status === 200) {
      delete response.status;
      yield put(updateLicenseSuccessful(license));
    } else {
      yield put(updateLicenseFailed({ message: response.message }));
    }
  } catch (error) {
    if (error.response) {
      yield put(
        updateLicenseFailed({
          message:
            "Error Code: " +
            error.response?.status +
            ", Message: " +
            error.response?.data,
        })
      );
    } else if (error.request) {
      yield put(updateLicenseFailed({ message: "No response received" }));
    }
    yield put(updateLicenseFailed({ message: error?.message }));
  }
}

function* addComplianceAddons({ payload: { complianceAddons } }) {
  try {
    console.log("about to call addComplianceAddons()");
    
    const payload = {
      "Compliance Add Ons": complianceAddons
    };
    
    const response = yield call(addComplianceAddonsApi, payload);
    
    console.log("addComplianceAddons() response: ", response);

    if (response && response.status === 200) {
      delete response.status;
      yield put(addComplianceAddonsSuccessful());
    } else {
      yield put(addComplianceAddonsFailed({ message: response.message }));
    }
  } catch (error) {
    if (error.response) {
      yield put(
        addComplianceAddonsFailed({
          message:
            "Error Code: " +
            error.response?.status +
            ", Message: " +
            error.response?.data,
        })
      );
    } else if (error.request) {
      yield put(addComplianceAddonsFailed({ message: "No response received" }));
    }
    yield put(addComplianceAddonsFailed({ message: error?.message }));
  }
}


export function* watchGlobalLicense() {
  // yield takeLatest(ADD_USER, addCognitoUser);
  // yield takeLatest(DELETE_COGNITO_USER, deleteCognitoUser);
  // yield takeLatest(UPDATE_COGNITO_USER, updateCognitoUser);
  yield takeLatest(GET_LICENSE, getLicense);
  yield takeLatest(UPDATE_LICENSE, updateLicense);
  yield takeLatest(ADD_COMPLIANCE_ADDONS, addComplianceAddons);
}

function* globalLicenseSaga() {
  yield all([fork(watchGlobalLicense)]);
}

export default globalLicenseSaga;
